<template>
  <Page color="grey" title="Einstellungen">
    <v-row>
      <v-col>
        <v-card max-width="500" class="mx-auto mb-4"
          ><v-system-bar>Namen von Personen</v-system-bar>
          <v-card-text>
            Wie sollen Namen von Peronen dargestellt werden?<br />
            Diese Einstellung beeinflusst die Reihenfolge bei sortierten Listen
            von Personen.
          </v-card-text>

          <v-list>
            <v-divider />
            <v-list-item-group v-model="peopleSort" mandatory>
              <v-list-item value="firstName">
                <template v-slot:default="{ active }">
                  <v-list-item-content>
                    <v-list-item-title
                      >zuerst Vorname, dann Nachname
                    </v-list-item-title>
                    <v-list-item-subtitle
                      >Listen sind nach Vornamen sortiert
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon v-if="active" color="primary"
                      >mdi-radiobox-marked</v-icon
                    >
                    <v-icon v-else color="primary">mdi-radiobox-blank</v-icon>
                  </v-list-item-action>
                </template>
              </v-list-item>

              <v-list-item value="lastName">
                <template v-slot:default="{ active }">
                  <v-list-item-content>
                    <v-list-item-title
                      >zuerst Nachname, dann Vorname
                    </v-list-item-title>
                    <v-list-item-subtitle
                      >Listen sind nach Nachnamen sortiert
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon v-if="active" color="primary"
                      >mdi-radiobox-marked</v-icon
                    >
                    <v-icon v-else color="primary">mdi-radiobox-blank</v-icon>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </v-list-item-group>
            <v-divider />
            <v-subheader>Beispiel</v-subheader>
            <PersonItem :value="$_profilePerson" :key="count" />
          </v-list>
        </v-card>
      </v-col>

      <v-col>
        <v-card max-width="500" class="mx-auto mb-4"
          ><v-system-bar>E-Mail-Client</v-system-bar>
          <v-card-text>
            Was soll bei einem Klick auf eine E-Mail geschehen? Soll diese in
            der Standard-E-Mail-App geöffnet werden oder auf unserer
            Outlook-Web-App?
          </v-card-text>

          <v-list>
            <v-divider />
            <v-list-item-group v-model="emailClient" mandatory>
              <v-list-item value="mailto">
                <template v-slot:default="{ active }">
                  <v-list-item-content>
                    <v-list-item-title>Standard-App </v-list-item-title>
                    <v-list-item-subtitle
                      >auf dem Gerät registrierte E-Mail-App verwenden
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon v-if="active" color="primary"
                      >mdi-radiobox-marked</v-icon
                    >
                    <v-icon v-else color="primary">mdi-radiobox-blank</v-icon>
                  </v-list-item-action>
                </template>
              </v-list-item>

              <v-list-item value="outlook">
                <template v-slot:default="{ active }">
                  <v-list-item-content>
                    <v-list-item-title>Outlook Web-App </v-list-item-title>
                    <v-list-item-subtitle
                      >im Browser in der Gymer-Cloud öffnen
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon v-if="active" color="primary"
                      >mdi-radiobox-marked</v-icon
                    >
                    <v-icon v-else color="primary">mdi-radiobox-blank</v-icon>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </v-list-item-group>
            <v-divider />
            <v-subheader>Beispiel</v-subheader>
            <v-card-text>
              <EmailChip :value="$_profilePerson.emailSchool" :key="count" />
            </v-card-text>
          </v-list>
        </v-card>
      </v-col>

      <v-col>
        <v-card max-width="500" class="mx-auto mb-4"
          ><v-system-bar>E-Mail-Trennzeichen</v-system-bar>
          <v-card-text>
            Mehrere Adressen werden offiziell mit einem Komma getrennt. Einige
            E-Mail-Apps (z.B. Outlook) verwenden jedoch ein Semikolon. Welches
            Trennzeichen soll verwendet werden?
          </v-card-text>

          <v-list>
            <v-divider />
            <v-list-item-group v-model="emailDivider" mandatory>
              <v-list-item value="comma">
                <template v-slot:default="{ active }">
                  <v-list-item-content>
                    <v-list-item-title>Komma </v-list-item-title>
                    <v-list-item-subtitle>
                      Mehrere Adressen werden mit einem Komma getrennt.
                      Offiziell korrekt, aber nicht von allen E-Mail-Apps
                      unterstützt.
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon v-if="active" color="primary"
                      >mdi-radiobox-marked</v-icon
                    >
                    <v-icon v-else color="primary">mdi-radiobox-blank</v-icon>
                  </v-list-item-action>
                </template>
              </v-list-item>

              <v-list-item value="semicolon">
                <template v-slot:default="{ active }">
                  <v-list-item-content>
                    <v-list-item-title>Semikolon </v-list-item-title>
                    <v-list-item-subtitle>
                      Mehrere Adressen werden mit einem Semikolon getrennt.
                      Offiziell nicht korrekt, aber z.B. für Outlook empfohlen.
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon v-if="active" color="primary"
                      >mdi-radiobox-marked</v-icon
                    >
                    <v-icon v-else color="primary">mdi-radiobox-blank</v-icon>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </v-list-item-group>
            <v-divider />
            <v-subheader>Beispiel</v-subheader>
            <v-card-text>
              {{
                joinEmails([
                  "support@gymkirchenfeld.ch",
                  "info@gymkirchenfeld.ch",
                ])
              }}
            </v-card-text>
          </v-list>
        </v-card>
      </v-col>

      <v-col>
        <v-card max-width="500" class="mx-auto mb-4"
          ><v-system-bar>Icons</v-system-bar>
          <v-card-text>
            Sollen bei den Absenzen und den Fächern die Symbole angezeigt werden
            oder nicht?<br />(an einigen wenigen Stellen können Symbole nicht
            ausgeblendet werden)
          </v-card-text>

          <v-list>
            <v-divider />
            <v-list-item-group v-model="hideIcons" mandatory>
              <v-list-item value="false">
                <template v-slot:default="{ active }">
                  <v-list-item-content>
                    <v-list-item-title>Icons anzeigen </v-list-item-title>
                    <v-list-item-subtitle
                      >Symbole werden überall angezeigt
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon v-if="active" color="primary"
                      >mdi-radiobox-marked</v-icon
                    >
                    <v-icon v-else color="primary">mdi-radiobox-blank</v-icon>
                  </v-list-item-action>
                </template>
              </v-list-item>

              <v-list-item value="true">
                <template v-slot:default="{ active }">
                  <v-list-item-content>
                    <v-list-item-title>Icons verbergen</v-list-item-title>
                    <v-list-item-subtitle
                      >Unterrichts- und Absenzen-Symbole werden nicht angezeigt
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon v-if="active" color="primary"
                      >mdi-radiobox-marked</v-icon
                    >
                    <v-icon v-else color="primary">mdi-radiobox-blank</v-icon>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </v-list-item-group>
            <v-divider />
            <v-subheader>Beispiel</v-subheader>
            <v-card-text>
              <v-chip outlined color="primary"
                ><v-icon left v-if="!hideIcons">mdi-account</v-icon
                ><PersonName :value="$_profilePerson"></PersonName
              ></v-chip>
            </v-card-text>
          </v-list>
        </v-card>
      </v-col>

      <v-col v-if="!$_hasRole('student')">
        <v-card max-width="500" class="mx-auto mb-4"
          ><v-system-bar>IBAN</v-system-bar>
          <v-card-text>
            Die hier gespeicherte IBAN wird bei Rechnungen mit «Zahlung an
            Mitarbeiter:in» verwendet.
          </v-card-text>

          <v-list>
            <v-divider />

            <v-list-item>
              <v-text-field
                v-model="invoiceIbanNew"
                label="IBAN"
                :rules="[rules.iban]"
              ></v-text-field>
            </v-list-item>
          </v-list>
          <v-divider />
          <v-card-actions>
            <v-btn
              text
              :disabled="invoiceIban == invoiceIbanNew"
              @click="invoiceIbanNew = invoiceIban"
              >abbrechen</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              text
              color="danger"
              :disabled="!invoiceIban || invoiceIban != invoiceIbanNew"
              @click="deleteIban"
              >Löschen</v-btn
            >

            <v-btn
              text
              color="primary"
              :disabled="
                !isValidIBANNumber(invoiceIbanNew) ||
                invoiceIban == invoiceIbanNew
              "
              @click="saveIban"
              >Speichern</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </Page>
</template>
<script>
import { defineComponent } from "vue";
import EmailChip from "common/components/EmailChip.vue";
import PersonItem from "common/components/PersonItem.vue";
import PersonName from "common/components/PersonName.vue";
import { getHideIcons, setHideIcons } from "common/utils/icons.js";
import { getPeopleSort, setPeopleSort } from "common/utils/people.js";
import { getEmailClient, setEmailClient } from "common/utils/helper.js";
import {
  getEmailDivider,
  setEmailDivider,
  joinEmails,
} from "common/utils/helper.js";
import {
  deleteIban,
  getIban,
  setIban,
  isValidIBANNumber,
} from "common/utils/finance.js";

export default defineComponent({
  components: { EmailChip, PersonItem, PersonName },
  name: "Settings",
  data() {
    return {
      email: "",
      emailClient: "",
      emailDivider: "comma",
      peopleSort: "",
      hideIcons: false,
      count: 0,
      loading: false,
      invoiceIban: "",
      invoiceIbanNew: "",
      rules: {
        iban: (value) => {
          return !value || isValidIBANNumber(value) || "Ungültige IBAN.";
        },
      },
    };
  },
  watch: {
    emailClient() {
      setEmailClient(this.emailClient);
      this.count = this.count + 1;
    },
    emailDivider() {
      setEmailDivider(this.emailDivider);
      this.count = this.count + 1;
    },

    peopleSort() {
      setPeopleSort(this.peopleSort);
      this.count = this.count + 1;
    },
    hideIcons() {
      setHideIcons(this.hideIcons);
      this.count = this.count + 1;
    },
  },
  methods: {
    joinEmails,
    isValidIBANNumber,
    async saveIban() {
      setIban(this.invoiceIbanNew);
      this.invoiceIban = this.invoiceIbanNew;
    },
    async deleteIban() {
      if (
        await this.$root.confirm({
          message: "Soll die IBAN wirklich gelöscht werden?",
          color: "danger",
          icon: "mdi-trash-can",
        })
      ) {
        this.invoiceIban = "";
        this.invoiceIbanNew = "";
        deleteIban();
      }
    },
  },

  async created() {
    this.emailClient = await getEmailClient();
    this.emailDivider = await getEmailDivider();
    this.invoiceIban = await getIban();
    this.invoiceIbanNew = this.invoiceIban;
    this.peopleSort = getPeopleSort();
    this.hideIcons = getHideIcons() ? "true" : "false";
  },
});
</script>
